'use client';

const getLoginUrl = () => {
    if (typeof window === 'undefined') {
        return '/login';
    }

    return `/login?returnUrl=${encodeURIComponent(window.location.pathname)}`;
};

export default getLoginUrl;
